import { Eye, EyeOff, FileText } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import api from "@/lib/api";
import { KINDS } from "@/components/webadvisor/ShareReportForm";
import { ConfirmDelete } from "@/components/admin/ConfirmDelete";

const B = process.env.REACT_APP_BACKEND_URL;
const KIND = { ...Object.fromEntries(KINDS), package: "Proposal", quote: "Quote" };

export const SharedReportsList = ({ docs, onChange, isAdmin, onDeleted }) => {
  const toggle = async (d) => {
    try { const { data } = await api.put(`/api/webadvisor/documents/${d.id}`, { visible: !d.visible }); onChange(data); toast.success(data.visible ? "Showing in their portal" : "Hidden from their portal"); }
    catch { toast.error("Couldn't update"); }
  };
  if (!docs.length) return <p className="text-sm text-slate-400 text-center py-8" data-testid="shared-reports-empty">Nothing shared yet. Reports you send appear here.</p>;
  return (
    <div className="divide-y divide-slate-100" data-testid="shared-reports-list">
      {docs.map(d => (
        <div key={d.id} className={`flex items-center gap-3 py-3 ${d.visible ? "" : "opacity-60"}`} data-testid={`shared-report-${d.id}`}>
          <FileText className="w-5 h-5 text-blue-600 shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="font-semibold text-slate-900 truncate">{d.title}</p>
            <p className="text-xs text-slate-500">{KIND[d.kind]}{d.mode ? ` (${d.mode})` : ""} · {d.created_at.slice(0, 10)} · {d.sent_by_name || d.sent_by}{d.emailed_to ? ` · emailed ${d.emailed_to}` : " · not emailed"}</p>
          </div>
          <a href={`${B}/api/documents/${d.id}/file`} target="_blank" rel="noreferrer" className="text-xs font-semibold text-blue-600 hover:underline shrink-0" data-testid={`shared-report-view-${d.id}`}>View</a>
          {isAdmin && <ConfirmDelete url={`/api/webadvisor/documents/${d.id}`} title="Delete this report?" description="It is removed from the customer's portal for good." onDone={() => onDeleted(d.id)} testId={`shared-report-delete-${d.id}`} />}
          <label className="flex items-center gap-1.5 text-xs text-slate-600 shrink-0" title={d.visible ? "Customer can see this" : "Hidden from customer"}>
            {d.visible ? <Eye className="w-3.5 h-3.5" /> : <EyeOff className="w-3.5 h-3.5" />}
            <Switch checked={d.visible} onCheckedChange={() => toggle(d)} data-testid={`shared-report-visible-${d.id}`} />
          </label>
        </div>
      ))}
    </div>
  );
};
